/* BootUp: predictive search, produktsammenligning */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK', minimumFractionDigits: 0, maximumFractionDigits: 2 });
  function kr(n) { return fmt.format(Number(n) || 0); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(u, w) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 120); }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    var input = document.getElementById('BuSearchInput');
    var box = document.getElementById('BuSearchResults');
    if (!input || !box) return;
    var timer, ctrl, active = -1;
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function render(q, products) {
      if (!products.length) { box.innerHTML = '<div class="bu-sr-empty">Ingen treff for «' + esc(q) + '»</div>'; }
      else {
        box.innerHTML = products.map(function (p, i) {
          var image = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          return '<a class="bu-sr-item" role="option" id="bu-sr-' + i + '" href="' + esc(p.url) + '">' +
            (image ? '<img src="' + esc(img(image, 120)) + '" alt="" loading="lazy">' : '<span class="bu-sr-ph"></span>') +
            '<span class="bu-sr-title">' + esc(p.title) + '</span><span class="bu-sr-price">' + kr(p.price) + '</span></a>';
        }).join('') + '<a class="bu-sr-all" href="' + ROOT + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">Vis alle resultater for «' + esc(q) + '»</a>';
      }
      box.hidden = false; input.setAttribute('aria-expanded', 'true');
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) { render(q, (d.resources && d.resources.results && d.resources.results.products) || []); })
          .catch(function () {});
      }, 180);
    });
    input.addEventListener('keydown', function (e) {
      var items = box.querySelectorAll('.bu-sr-item');
      if (e.key === 'Escape') { close(); return; }
      if (!items.length || box.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (el, i) { el.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
        input.setAttribute('aria-activedescendant', items[active].id);
      } else if (e.key === 'Enter' && active > -1) { e.preventDefault(); window.location = items[active].href; }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.bu-search')) close(); });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length > 1) { box.hidden = false; } });
  }

  /* ---------- Sammenligning ---------- */
  var KEY = 'bootupCompare', MAX = 4, cache = {};
  function getList() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function setList(l) { localStorage.setItem(KEY, JSON.stringify(l.slice(0, MAX))); sync(); }
  function fetchProduct(h) {
    if (!cache[h]) cache[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); });
    return cache[h];
  }
  function toast(msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);background:#1F6BFF;color:#fff;padding:10px 16px;border-radius:8px;z-index:70;font-size:.9rem';
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2600);
  }
  function sync() {
    var list = getList();
    document.querySelectorAll('[data-bu-compare]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.dataset.buCompare) > -1 ? 'true' : 'false'); });
    var bar = document.getElementById('BuCompareBar');
    if (!bar) return;
    var onComparePage = !!document.getElementById('BuComparePage');
    if (!list.length || onComparePage) { bar.hidden = true; document.body.style.paddingBottom = ''; }
    else { bar.hidden = false; document.body.style.paddingBottom = '84px'; }
    document.getElementById('BuCompareCount').textContent = list.length + ' av ' + MAX + ' valgt';
    var wrap = document.getElementById('BuCompareItems');
    wrap.innerHTML = list.map(function (h) { return '<div class="bu-cb-item" data-h="' + esc(h) + '"><button type="button" aria-label="Fjern" data-bu-remove="' + esc(h) + '">×</button></div>'; }).join('');
    list.forEach(function (h) {
      fetchProduct(h).then(function (p) {
        var el = wrap.querySelector('[data-h="' + h + '"]');
        if (el && p.featured_image) el.insertAdjacentHTML('afterbegin', '<img src="' + esc(img(p.featured_image, 120)) + '" alt="' + esc(p.title) + '">');
      }).catch(function () {});
    });
    if (onComparePage) renderComparePage();
  }
  function toggle(h) {
    var list = getList(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1);
    else { if (list.length >= MAX) { toast('Du kan sammenligne maks ' + MAX + ' produkter'); return; } list.push(h); }
    setList(list);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bu-compare]');
    if (b) { e.preventDefault(); e.stopPropagation(); toggle(b.dataset.buCompare); return; }
    var r = e.target.closest('[data-bu-remove]');
    if (r) { e.preventDefault(); var l = getList(); l.splice(l.indexOf(r.dataset.buRemove), 1); setList(l); return; }
    if (e.target.id === 'BuCompareClear' || e.target.id === 'BuComparePageClear') { setList([]); }
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  function specsFromDescription(html) {
    var specs = {}, order = [];
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    doc.querySelectorAll('tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('th,td');
      if (cells.length >= 2) {
        var k = cells[0].textContent.trim().replace(/:$/, ''), v = cells[1].textContent.trim();
        if (k && v && k.length < 80 && !(k in specs)) { specs[k] = v; order.push(k); }
      }
    });
    if (!order.length) {
      doc.querySelectorAll('li').forEach(function (li) {
        var m = li.textContent.trim().match(/^([^:]{2,60}):\s*(.+)$/);
        if (m && !(m[1] in specs)) { specs[m[1]] = m[2]; order.push(m[1]); }
      });
    }
    return { specs: specs, order: order };
  }
  var renderSeq = 0;
  function renderComparePage() {
    var root = document.getElementById('BuComparePage');
    if (!root) return;
    var seq = ++renderSeq, list = getList();
    if (!list.length) {
      root.innerHTML = '<div class="bu-compare__empty"><p>Du har ikke valgt noen produkter ennå.</p><p>Huk av «Sammenlign» på produktkort eller produktsider (maks ' + MAX + ').</p><p><a class="bu-btn" href="' + ROOT + 'collections/all">Se produkter</a></p></div>';
      return;
    }
    root.innerHTML = '<p class="bu-compare__intro">Henter produkter …</p>';
    Promise.all(list.map(function (h) { return fetchProduct(h).catch(function () { return null; }); })).then(function (ps) {
      if (seq !== renderSeq) return;
      ps = ps.filter(Boolean);
      var parsed = ps.map(function (p) { return specsFromDescription(p.description); });
      var keys = [];
      parsed.forEach(function (s) { s.order.forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); }); });
      var head = '<tr><th scope="row">Produkt</th>' + ps.map(function (p) {
        return '<td class="bu-compare__card">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 400)) + '" alt="">' : '') +
          '<a href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="bu-compare__price">' + kr(p.price / 100) + '</div>' +
          (p.compare_at_price > p.price ? '<div><s>' + kr(p.compare_at_price / 100) + '</s></div>' : '') +
          '<button type="button" class="bu-compare__remove" data-bu-remove="' + esc(p.handle) + '">Fjern</button></td>';
      }).join('') + '</tr>';
      function row(label, vals) {
        var diff = vals.filter(function (v, i, a) { return a.indexOf(v) === i; }).length > 1;
        return '<tr' + (diff ? ' class="bu-diff"' : '') + '><th scope="row">' + esc(label) + '</th>' + vals.map(function (v) { return '<td>' + (v ? esc(v) : '–') + '</td>'; }).join('') + '</tr>';
      }
      var rows = row('Produsent', ps.map(function (p) { return p.vendor; })) +
        row('Produkttype', ps.map(function (p) { return p.type; })) +
        row('Lagerstatus', ps.map(function (p) { return p.available ? 'På lager' : 'Ikke på lager'; }));
      keys.forEach(function (k) { rows += row(k, parsed.map(function (s) { return s.specs[k] || ''; })); });
      root.innerHTML = '<div class="bu-compare__toolbar"><span>' + ps.length + ' av ' + MAX + ' produkter · rader med forskjeller er markert med blå strek</span><button type="button" class="bu-link" id="BuComparePageClear">Tøm sammenligning</button></div>' +
        '<div class="bu-compare__scroll"><table><tbody>' + head + rows + '</tbody></table></div>' +
        (keys.length ? '' : '<p class="bu-compare__intro" style="margin-top:14px">Detaljerte spesifikasjoner vises når produktbeskrivelsen har en spesifikasjonstabell.</p>');
    });
  }

  function init() { initSearch(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Horizon laster inn kort dynamisk (filtre, uendelig scroll) */
  if (window.MutationObserver) {
    var pend;
    new MutationObserver(function () { clearTimeout(pend); pend = setTimeout(function () {
      var list = getList();
      document.querySelectorAll('[data-bu-compare]').forEach(function (b) { b.setAttribute('aria-pressed', list.indexOf(b.dataset.buCompare) > -1 ? 'true' : 'false'); });
    }, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
